export class ErrorMessage {
  title: string = "";
  message: string = "";

  constructor(title: string, message: string) {
    this.title = title;
    this.message = message;
  }
}
